import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { Enquiry } from "./enquiry.model";
import { EnquiryListing } from "./enquiry-listing.model";
import { EnquiryOptions } from "./enquiry-options.model";
import { QuoteDocGenData } from "./quote-doc-gen-data.model";
import { RepaymentCalculation } from "./repayment-calculation.model";
import { RepaymentOption } from "./repayment-option.model";
import { handleError } from "../../shared/handle-error";
import { VirtualRepeatContainer } from "../../shared/virtual-repeat-container.model";

@Injectable()
export class EnquiryService {
    private enquiriesUrl = "api/enquiries";  // url to web api
    private defaultEnquiry: Enquiry;

    constructor(
        private http: HttpClient) {

        this.defaultEnquiry = {
            id: null,
            enquiryNumber: null,
            introducerRateChartID: null,
            assetTypeGroupID: null,
            costOfGoods: null,
            isAdvance: null,
            paymentFrequencyID: null,
            repayment: null,
            term: null,
            contactName: null,
            businessName: null,
            emailAddress: null,
            submittedOn: null,
        }
    }

    create(enq: Enquiry): Promise<Enquiry> {
        return this.http.post(this.enquiriesUrl, enq)
            .toPromise()
            .catch(handleError);
    }

    getEnquiry(id: number): Promise<Enquiry> {
        if (!id) {
            return Promise.resolve(this.defaultEnquiry);
        }

        const url = `${this.enquiriesUrl}/${id}`;
        return this.http.get<Enquiry>(url)
            .toPromise()
            .catch(handleError);
    }

    // Virtual scroll EnquiryListing implementation - removed for now, since generated SQL is not compatible with SQL2008R2
    //getListing(skip: number, take: number, sortBy: string, sortDirection: string, searchString: string): Observable<VirtualRepeatContainer<EnquiryListing>> {
    //    return this.http.get<VirtualRepeatContainer<EnquiryListing>>(this.enquiriesUrl, {
    //        params: new HttpParams()
    //            .set("skip", (skip != null) ? String(skip) : "")
    //            .set("take", (take != null) ? String(take) : "")
    //            .set("sortBy", (sortBy != null) ? String(sortBy) : "")
    //            .set("sortDirection", (sortDirection != null) ? String(sortDirection) : "")
    //            .set("searchString", (searchString != null) ? String(searchString) : "")
    //    })
    //    .catch(handleError);;
    //}

    getListing(monthsAgo: number): Promise<EnquiryListing[]> {
        return this.http.get<EnquiryListing[]>(this.enquiriesUrl, {
                params: new HttpParams().set("monthsAgo", (monthsAgo != null) ? String(monthsAgo) : "")
            })
            .toPromise()
            .catch(handleError);;
    }

    getOptions(): Promise<EnquiryOptions> {
        const url = `${this.enquiriesUrl}/options`;
        return this.http.get<EnquiryOptions>(url)
            .toPromise()
            .catch(handleError);
    }

    getRepaymentOptions(calcParams: RepaymentCalculation): Observable<RepaymentOption[]> {
        return this.http.post(`${this.enquiriesUrl}/repayments`, calcParams)
            .pipe(catchError(handleError));
    }

    submit(enq: Enquiry): Promise<Enquiry> {
        return this.http
            .post(`${this.enquiriesUrl}/submit`, enq, {
                params: new HttpParams().set("id", (enq.id != null ? String(enq.id) : ""))
            })
            .toPromise()
            .catch(handleError);
    }

    update(enq: Enquiry): Promise<Enquiry> {
        const url = `${this.enquiriesUrl}/${enq.id}`;
        return this.http.put(url, enq)
            .toPromise()
            .then(() => enq)
            .catch(handleError);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/shared/enquiry.service.ts